import BackButton from 'v2/components/BackButton';
import Icon from 'v2/components/Icon';
import Box from 'v2/components/UI/Box';
import ButtonBase from 'v2/components/UI/ButtonBase';
import Text from 'v2/components/UI/Text';
import useSettings from './hooks/useSettings';

//TODO: REFACTOR IN UPDATE REACT
const Settings: React.FC = () => {
  const { handleNavigateAddFiles, handleNavigateListFiles } = useSettings();
  return (
    <Box flexDirection="column" gap={30} padding={10}>
      <BackButton title="Voltar aos chats" />

      <Box flexDirection="column" gap={15}>
        <Text fontSize={22} fontWeight={700} color="#005F47">
          Configurações
        </Text>

        <Box
          background={'#fff'}
          borderRadius={12}
          padding={10}
          width={'100%'}
          gap={15}
          flexDirection="column"
        >
          <Text fontSize={16} fontWeight={500} color="#005F47">
            Arquivos
          </Text>

          <Box flexDirection="column" gap={5}>
            <ButtonBase
              alignItems="center"
              gap={10}
              padding={10}
              borderRadius={8}
              onClick={handleNavigateAddFiles}
            >
              <Box
                background="#005f4721"
                borderRadius={8}
                padding={5}
                alignItems="center"
                justifyContent="center"
              >
                <Icon iconName="AddOutlined" htmlColor="#005F47" size={18} />
              </Box>
              <Text fontSize={14} fontWeight={500} color="#005F47">
                Adicionar Arquivo
              </Text>
            </ButtonBase>

            <ButtonBase
              alignItems="center"
              gap={10}
              padding={10}
              borderRadius={8}
              onClick={handleNavigateListFiles}
            >
              <Box
                background="#005f4721"
                borderRadius={8}
                padding={5}
                alignItems="center"
                justifyContent="center"
              >
                <Icon
                  iconName="SummarizeOutlined"
                  htmlColor="#005F47"
                  size={18}
                />
              </Box>
              <Text fontSize={14} fontWeight={500} color="#005F47">
                Lista com todos os arquivos
              </Text>
            </ButtonBase>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Settings;
